import { combineReducers } from "redux";

import Order from "./order.reducer";
import RefundOrder from "./refundOrder.reducer";
import System from "./system.reducer";

const rootReducer = combineReducers({
  Order: Order,
  RefundOrder: RefundOrder,
  System: System,
});

export default rootReducer;
